import { render, staticRenderFns } from "./ModalStartQuestionary.vue?vue&type=template&id=12dc6a5d&scoped=true&"
import script from "./ModalStartQuestionary.vue?vue&type=script&lang=js&"
export * from "./ModalStartQuestionary.vue?vue&type=script&lang=js&"
import style0 from "./ModalStartQuestionary.vue?vue&type=style&index=0&id=12dc6a5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dc6a5d",
  null
  
)

export default component.exports